module.exports = new __parcel__URL__("PlatinumMiniPartnerBadge.static.37515d24.svg").toString();